@if (displayedCourses) {
  <div class="course-card">
    <div mat-dialog-title>{{ 'Global.contentAccess' | translate }}</div>
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>{{ 'Global.search' | translate }}</mat-label>
      <input matInput [(ngModel)]="searchTerm" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="full-width mb-1">
      <button mat-flat-button color="primary" (click)="searchCoursesByName()">
        {{ 'Global.search' | translate }}
      </button>
    </div>
    @if (displayedCourses.length > 0) {
      <div class="result-box">
        @for (course of displayedCourses; track course) {
          <mat-card appearance="outlined" class="result-item">
            <mat-card-content>
              <mat-card-title>
                <strong>{{ languageIsFr() ? course.name_fr : course.name_en }}</strong>
              </mat-card-title>
              <p class="description">
                {{ languageIsFr() ? course.desc_fr : course.desc_en }}
              </p>
            </mat-card-content>
            <mat-card-actions class="bottom-card-flex">
              @if (!course.hasAcces && !requestIsOngoing(course._id)) {
                <mat-form-field appearance="fill">
                  <mat-label>{{ 'Global.Recipient' | translate }}</mat-label>
                  <mat-select [(value)]="course.approverID">
                    @for (user of course.admins; track user) {
                      <mat-option [value]="user.id">
                        {{ user.firstName + ' ' + user.lastName }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (!course.hasAcces && !requestIsOngoing(course._id)) {
                <button mat-flat-button color="primary" [disabled]="loading || !course.approverID" (click)="sendCourseRequest(course._id, course.approverID)">
                  {{ 'Global.RequestAccess' | translate }}
                </button>
              }
              @if (requestIsOngoing(course._id) && !course.hasAcces) {
                <div>
                  <mat-label>{{ 'Global.PendingRequest' | translate }}</mat-label>
                  <button mat-button [disabled]="loading" (click)="cancelRequest(course._id)">
                    {{ 'Global.CancelRequest' | translate }}
                  </button>
                </div>
              }
              @if (course.hasAcces) {
                <mat-label class="pb-1">{{ 'Global.AlreadyHaveAccess' | translate }}</mat-label>
              }
            </mat-card-actions>
          </mat-card>
        }
      </div>
    }
    <!-- <div *ngIf="displayedCourses.length == 0" class="text-center p-1">Aucun cours disponible</div> -->
  </div>
}
